"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var siema_1 = __importDefault(require("modules/siema"));
var Block_1 = require("modules/Block");
var Initializer_1 = require("modules/Initializer");
require("./carousel-block.scss");
var CarouselBlock = (function (_super) {
    __extends(CarouselBlock, _super);
    function CarouselBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CarouselBlock.prototype.init = function () {
        var _this = this;
        var siema = this.rootElement.querySelector(".siema");
        if (!siema)
            return;
        function changeSlideInidicator() {
            var _this = this;
            var indicatorContainer = this.rootElement.nextElementSibling;
            if (!indicatorContainer)
                return;
            var indicators = indicatorContainer.querySelectorAll(".slide__indicator");
            indicators.forEach(function (indicator) {
                if (_this.currentSlide == parseInt(indicator.getAttribute("data-index") || "-1")) {
                    indicator.classList.add("active");
                }
                else {
                    indicator.classList.remove("active");
                }
            });
        }
        this.slider = new siema_1.default({
            loop: true,
            duration: 200,
            selector: siema,
            onChange: changeSlideInidicator,
        });
        var timeToSlide = Number(this.slider.rootElement.dataset.slide);
        if (timeToSlide === 0 || isNaN(timeToSlide)) {
            timeToSlide = 5000;
        }
        var timerID = setInterval(function () {
            var _a;
            (_a = _this.slider) === null || _a === void 0 ? void 0 : _a.next();
        }, timeToSlide);
        var controlsContainer = this.slider.rootElement.nextElementSibling;
        if (!controlsContainer)
            return;
        var prevButton = controlsContainer.querySelector(".carousel__prev");
        var nextButton = controlsContainer.querySelector(".carousel__next");
        var pauseButton = controlsContainer.querySelector(".carousel__pause");
        prevButton === null || prevButton === void 0 ? void 0 : prevButton.addEventListener("click", function () {
            var _a;
            (_a = _this.slider) === null || _a === void 0 ? void 0 : _a.prev();
        });
        nextButton === null || nextButton === void 0 ? void 0 : nextButton.addEventListener("click", function () {
            var _a;
            (_a = _this.slider) === null || _a === void 0 ? void 0 : _a.next();
        });
        pauseButton === null || pauseButton === void 0 ? void 0 : pauseButton.addEventListener("click", function (e) {
            if (!e.target || !(e.target instanceof Element))
                return;
            e.target.classList.toggle("is-paused");
            if (e.target.classList.contains("is-paused")) {
                clearInterval(timerID);
            }
            else {
                timerID = setInterval(function () {
                    var _a;
                    (_a = _this.slider) === null || _a === void 0 ? void 0 : _a.next();
                }, timeToSlide);
            }
        });
    };
    return CarouselBlock;
}(Block_1.Block));
Initializer_1.Initializer.initBlock(".js-carousel-block", CarouselBlock);
